import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function MaintenanceToggle() {
  const { t } = useTranslation();
  const maintenanceMode = SettingsStore(state => state.maintenanceMode);
  const setMaintenanceMode = SettingsStore(state => state.setMaintenanceMode);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="maintenance-mode">
          {t("settings.maintenanceMode")}
        </Label>
        <Switch
          id="maintenance-mode"
          checked={maintenanceMode}
          onCheckedChange={setMaintenanceMode}
          disabled={isLoading}
        />
      </div>
    </ControlWrapper>
  );
}
